import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarRegisterList } from "../../../../../../../services/ticketAutomationReceivedSlotCalendar.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.appointmentArrival.";

export const Calendars = memo(
  ({ type }: { type: "exam" | "consultation" }) => {
    const { t } = useTranslation();

    const { sendRequest } = useFetch(calendarRegisterList);

    const [optionsCalendars, setOptionsCalendars] = useState<ISelectType[]>([]);

    const fetchCalendars = useCallback(async () => {
      const { data, success } = await sendRequest({
        tasyScheduleTypeCode: type === "consultation" ? 3 : 2,
      });
      if (data && success) {
        setOptionsCalendars(
          data.map((calendar) => ({
            id: calendar.identifier.toString(),
            name: `${calendar.descriptionSite?.trim() || calendar.calendarName} - ${calendar.identifier}`,
          })),
        );
      }
    }, [sendRequest, type]);

    useEffect(() => {
      fetchCalendars();
    }, [fetchCalendars]);

    return (
      <Grid item xs={12}>
        <AutoCompleteMulti
          name="calendars"
          size="small"
          options={optionsCalendars}
          label={t(translationPath + "calendars")}
          getOptionLabel={(option) => option.name}
          fullWidth
          keepOpenOnSelect
        />
      </Grid>
    );
  },
);
